import { useMarketingTileGroupsQuery } from 'generated/sanity-graphql';

export const useMarketingTileGroups = (ids?: string[]) => {
  const marketingTileGroupIds = ids ?? [];
  const { data, loading } = useMarketingTileGroupsQuery({
    variables: {
      where: {
        _id: { in: marketingTileGroupIds },
      },
    },
    skip: !marketingTileGroupIds?.length,
  });

  const marketingTileGroups = data?.allMarketingTileGroup;

  return {
    marketingTileGroups,
    marketingTileGroupsLoading: loading,
  };
};
